module.exports = __webpack_public_path__ + "static/media/logo.7e11e4c1.png";